import createStore from "zustand";
import { Grant, TrustDetails } from "../types/Grant";
import { OptionSplit } from "../types/OptionSplit";
import { VestingEventReq, VestingTemplate } from "../types/VestingTemplate";

interface GrantDialog {
  open: boolean;
  grant?: Grant;
  grantId?: string;
  variant?: "created" | "edit" | "state change";
  isEmployeeRaised?: boolean;
  id?: string;
}

interface TrustDialog {
  open: boolean;
  mode?: "Add" | "Edit";
  trust?: TrustDetails;
}

interface AccelerateDialog {
  open: boolean;
  grant?: Grant;
}

interface VestingDialog {
  open: boolean;
  template?: VestingTemplate;
  mode?: "Add" | "Edit" | "View";
}
interface PaymentDialog {
  open: boolean;
  link?: string;
  eventId?: string;
  mode?: "Add" | "Edit" | "View";
}
interface EventDialog {
  open: boolean;
  event?: VestingEventReq;
  variant?: "edit" | "complete";
}

interface OptionSplitDialog {
  open: boolean;
  split?: OptionSplit;
  mode?: "Add" | "Edit" | "View";
}
interface AdvanceFilterDialog {
  open: boolean;
  id?: string;
}
interface ShowSignaturePadDialog {
  open: boolean;
  ids?: string[];
  entityType?: string;
  signatureType?: string;
  signature?: string;
  isLoading?: boolean;
}
interface StateStore<T> {
  state: T;
  setState: (state: T | ((state?: T) => T)) => void;
}

export const useExerciseRequestDialog = createStore<StateStore<GrantDialog>>(
  (set) => ({
    state: { open: false },
    setState: (input) => {
      if (typeof input === "function") {
        return set((store) => ({ ...store, state: input(store.state) }));
      } else {
        return set((store) => ({ ...store, state: input }));
      }
    },
  })
);

export const useEditEventDetailsDialog = createStore<StateStore<EventDialog>>(
  (set) => ({
    state: { open: false },
    setState: (input) => {
      if (typeof input === "function") {
        return set((store) => ({ ...store, state: input(store.state) }));
      } else {
        return set((store) => ({ ...store, state: input }));
      }
    },
  })
);

export const useExerciseApproveDialog = createStore<StateStore<GrantDialog>>(
  (set) => ({
    state: { open: false },
    setState: (input) => {
      if (typeof input === "function") {
        return set((store) => ({ ...store, state: input(store.state) }));
      } else {
        return set((store) => ({ ...store, state: input }));
      }
    },
  })
);

export const useVestingApproveDialog = createStore<StateStore<GrantDialog>>(
  (set) => ({
    state: { open: false },
    setState: (input) => {
      if (typeof input === "function") {
        return set((store) => ({ ...store, state: input(store.state) }));
      } else {
        return set((store) => ({ ...store, state: input }));
      }
    },
  })
);

export const useVestingScheduleDialog = createStore<StateStore<VestingDialog>>(
  (set) => ({
    state: { open: false },
    setState: (input) => {
      if (typeof input === "function") {
        return set((store) => ({ ...store, state: input(store.state) }));
      } else {
        return set((store) => ({ ...store, state: input }));
      }
    },
  })
);

export const useTrustDialog = createStore<StateStore<TrustDialog>>((set) => ({
  state: { open: false },
  setState: (input) => {
    if (typeof input === "function") {
      return set((store) => ({ ...store, state: input(store.state) }));
    } else {
      return set((store) => ({ ...store, state: input }));
    }
  },
}));

export const useGrantCreatedDialog = createStore<StateStore<GrantDialog>>(
  (set) => ({
    state: { open: false },
    setState: (input) => {
      if (typeof input === "function") {
        return set((store) => ({ ...store, state: input(store.state) }));
      } else {
        return set((store) => ({ ...store, state: input }));
      }
    },
  })
);

export const useAccelerateVestingDialog = createStore<
  StateStore<AccelerateDialog>
>((set) => ({
  state: { open: false },
  setState: (input) => {
    if (typeof input === "function") {
      return set((store) => ({ ...store, state: input(store.state) }));
    } else {
      return set((store) => ({ ...store, state: input }));
    }
  },
}));

export const useOptionSplitDialog = createStore<StateStore<OptionSplitDialog>>(
  (set) => ({
    state: { open: false },
    setState: (input) => {
      if (typeof input === "function") {
        return set((store) => ({ ...store, state: input(store.state) }));
      } else {
        return set((store) => ({ ...store, state: input }));
      }
    },
  })
);

export const useAdvanceFilterDialog = createStore<
  StateStore<AdvanceFilterDialog>
>((set) => ({
  state: { open: false },
  setState: (input) => {
    if (typeof input === "function") {
      return set((store) => ({ ...store, state: input(store.state) }));
    } else {
      return set((store) => ({ ...store, state: input }));
    }
  },
}));

export const useSignaturePadDialog = createStore<
  StateStore<ShowSignaturePadDialog>
>((set) => ({
  state: { open: false },
  setState: (input) => {
    if (typeof input === "function") {
      return set((store) => ({ ...store, state: input(store.state) }));
    } else {
      return set((store) => ({ ...store, state: input }));
    }
  },
}));

export const useEditPaymentLinkDialog = createStore<StateStore<PaymentDialog>>(
  (set) => ({
    state: { open: false },
    setState: (input) => {
      if (typeof input === "function") {
        return set((store) => ({ ...store, state: input(store.state) }));
      } else {
        return set((store) => ({ ...store, state: input }));
      }
    },
  })
);
